<template>
  <q-page>
    <div class="q-pa-md">
      <div class="row q-col-gutter-md q-mb-md">
        <div class="col-9">
          <div class="row">
            <div class="page-title q-mr-sm">Units</div>
            <div>
              <q-btn
                color="primary"
                :loading="isLoading"
                class="float-right sustainability-button"
                @click="onAddUnitClick"
              >
                <q-icon name="mdi-plus-circle"> </q-icon>
                <span
                  class="sustainability-font q-mx-sm"
                  style="font-size: 13px"
                >
                  Add
                </span>
              </q-btn>
            </div>
          </div>
        </div>
        <div class="col-3">
          <q-input
            class="searchbar float-right"
            style="max-width: 70%"
            filled
            v-model="searchText"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"></q-icon>
            </template>
          </q-input>
        </div>
      </div>
      <div class="row">
        <q-card class="full-width">
          <sustainability-data-table
            flat
            headerBgColor="#162c47"
            headerTextColor="white"
            :filter="searchText"
            :columns="columns"
            :data="data"
            @rowDoubleClick="onRowDoubleClick"
          >
          </sustainability-data-table>
        </q-card>
      </div>
    </div>
    <q-dialog v-model="unitDialog" full-height full-width>
      <unit-form @closeDialog="unitDialog = false"> </unit-form>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import UnitForm from "@/components/units/unitForm.vue";
import SustainabilityDataTable from "@/components/datatable/sustainabilityDatatable.vue";
export default {
  data: () => ({
    searchText: "",
    unitDialog: false,
    isLoading: false,
  }),
  components: {
    SustainabilityDataTable,
    UnitForm,
  },
  computed: {
    ...mapGetters({
      data: "units/list",
    }),
    dataGridCSS() {
      return [
        'font-family: "Montserrat";',
        "font-style: normal;",
        "font-weight: 400;",
        "font-size: 14px;",
        "line-height: 13px;",
      ].join(";");
    },
    columns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 60px;max-width: 60px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
            this.dataGridCSS,
          sortable: true,
        },
        {
          name: "unit",
          label: "Unit",
          align: "left",
          field: "name",
          style:
            "min-width: 300px;max-width: 300px;width: 180px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
            this.dataGridCSS,
          sortable: true,
        },
        {
          name: "abbreviation",
          label: "Abbreviation",
          align: "left",
          field: "shortName",
          style:
            "min-width:180px;max-width:180px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
            this.dataGridCSS,
          sortable: true,
        },
        {
          name: "createdAt",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) => {
            return this.$options.filters.gridDateFormat(val);
          },
          style:
            "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" +
            this.dataGridCSS,
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "right",
        },
      ];
    },
  },
  mounted() {
    this.$store.dispatch("units/loadAll");
  },

  watch: {
    $route: {
      handler(value) {
        if (value.params.hasOwnProperty("id")) {
          this.openSelectedUnit(value.params.id);
        }
      },
    },
  },
  methods: {
    onRowDoubleClick(row) {
      this.$router.push("/units/" + row.id);
    },
    async onAddUnitClick() {
      this.isLoading = true;
      let result = await this.$store.dispatch("units/new", {
        status: "temp",
      });
      this.$router.push("/units/" + parseFloat(result.Response.newUnitId));
      this.isLoading = false;
    },
    openSelectedUnit(id) {
      this.$store.commit("units/setSelectedUnit", null);
      this.$store.dispatch("units/loadByID", id);
      this.$nextTick(() => (this.unitDialog = true));
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
}
.sustainability-button {
  height: 34px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: 11px;
  display: flex;
  align-items: center;
  text-align: center;
}
</style>
